import { css } from "styled-components"

//MEDIA QUERIES
export const breakpoint = {
  xs: "576px",
  sm: "576px",
  md: "768px",
  lg: "1024px",
  xl: "1200px",
  xxl: "1400px",
  bgxl: "1920px",
}

export const media = {
  bgxl: (...args) =>
    css`
      @media screen and (max-width: ${breakpoint.bgxl}) {
        ${css(...args)}
      }
    `,
  xxl: (...args) =>
    css`
      @media screen and (min-width: ${breakpoint.xxl}) {
        ${css(...args)}
      }
    `,
  xl: (...args) =>
    css`
      @media screen and (min-width: ${breakpoint.xl}) {
        ${css(...args)}
      }
    `,
  lg: (...args) =>
    css`
      @media screen and (min-width: ${breakpoint.lg}) {
        ${css(...args)}
      }
    `,
  md: (...args) =>
    css`
      @media screen and (min-width: ${breakpoint.md}) {
        ${css(...args)}
      }
    `,
  sm: (...args) =>
    css`
      @media screen and (min-width: ${breakpoint.sm}) {
        ${css(...args)}
      }
    `,
  xs: (...args) =>
    css`
      @media screen and (max-width: ${breakpoint.xs}) {
        ${css(...args)}
      }
    `,
}

// COLORS
export const color = {
  bronze: `#B1A798`,
}
// ---
